import React from 'react';

import SvgContainer from '../SvgContainer';

const BurgerMenu = () => {
    return (
        <SvgContainer>
            <path d="M0 12.5833C0 13.0896 0.410406 13.5 0.916666 13.5H15.0833C15.5896 13.5 16 13.0896 16 12.5833C16 12.0771 15.5896 11.6667 15.0833 11.6667H0.916666C0.410405 11.6667 0 12.0771 0 12.5833ZM0 8C0 8.50626 0.410406 8.91667 0.916666 8.91667H15.0833C15.5896 8.91667 16 8.50626 16 8C16 7.49374 15.5896 7.08333 15.0833 7.08333H0.916666C0.410405 7.08333 0 7.49374 0 8ZM0.916666 2.5C0.410405 2.5 0 2.91041 0 3.41667C0 3.92293 0.410406 4.33333 0.916666 4.33333H15.0833C15.5896 4.33333 16 3.92293 16 3.41667C16 2.91041 15.5896 2.5 15.0833 2.5H0.916666Z" />
        </SvgContainer>
    );
};

export default BurgerMenu;
